"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const icons_1 = require("@material-ui/icons");
const Table_1 = __importDefault(require("@material-ui/core/Table"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const components_1 = require("@alcumus/components");
const react_router_dom_1 = require("react-router-dom");
const ReportOptionsColumn_1 = __importDefault(require("../ReportTable/ReportOptionsColumn"));
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const SortableTableHeader_1 = __importDefault(require("../ReportTable/SortableTableHeader"));
const EmptyFolderState_1 = __importDefault(require("../EmptyState/EmptyFolderState"));
const FavoriteContentButton_1 = __importDefault(require("../shared/FavoriteContentButton"));
const handleOnDeleteFavorite_1 = __importDefault(require("../ReportTable/handleOnDeleteFavorite"));
const ShowMoveFunction_1 = require("../shared/ShowMoveFunction");
const StyledTableCell = (0, styles_1.withStyles)(() => ({
    root: {
        padding: '8px 16px',
    },
}))(TableCell_1.default);
const useStyles = (0, styles_1.makeStyles)({
    tableContainer: {
        boxShadow: 'none !important',
        paddingTop: 0,
    },
    icon: {
        color: components_1.StyleVariables.colors.grey4,
    },
    customNavLink: {
        color: components_1.StyleVariables.colors.text.default,
        textDecoration: 'underline',
        '&:hover': {
            color: components_1.StyleVariables.colors.text.info,
        },
    },
    sortIcon: {
        position: 'absolute',
        paddingLeft: 4,
    },
    kebabColumn: {
        padding: 0,
        width: 55,
    },
});
const SubFolderTableView = ({ data, headers, showOwner = false, showDashboardCount = false, showLookCount = false, showFavorite = false, isLoading, showCreateButton, removeFavoriteFromTable, }) => {
    const classes = useStyles();
    const [sortConfig, updateSortConfig] = (0, react_1.useState)([]);
    const [tableRow, setTableRow] = (0, react_1.useState)();
    const sortedRows = (0, react_1.useMemo)(() => {
        if (!sortConfig.length) {
            return [...data];
        }
        function descendingComparator(a, b, orderBy) {
            if (b[orderBy] < a[orderBy])
                return -1;
            if (b[orderBy] > a[orderBy])
                return 1;
            return 0;
        }
        function getComparator(a, b, config) {
            const result = descendingComparator(a, b, config.propertyName);
            return config.sortType === 'desc' ? result : -result;
        }
        const sorted = [...data].sort((a, b) => {
            for (const config of sortConfig) {
                const result = getComparator(a, b, config);
                if (result !== 0) {
                    return result;
                }
            }
            return 0;
        });
        return sorted;
    }, [sortConfig, data]);
    const handleChange = (pendingChange) => {
        updateSortConfig([...pendingChange]);
    };
    const canSeeKebabMenu = (row) => {
        return ((row.elementType === reportElementTypes_1.ReportElementTypes.Folder && row.can?.editContent) ||
            row.elementType !== reportElementTypes_1.ReportElementTypes.Folder);
    };
    const hasContent = () => {
        return !isLoading && data.length !== 0;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableContainer_1.default, { className: classes.tableContainer, component: Paper_1.default },
            react_1.default.createElement(Table_1.default, { "aria-label": "Record Table", "data-testid": "recordTable" },
                react_1.default.createElement(SortableTableHeader_1.default, { headers: headers, sortConfig: sortConfig, handleClick: handleChange }),
                hasContent() && (react_1.default.createElement(TableBody_1.default, null, sortedRows.map((row) => {
                    return (react_1.default.createElement(TableRow_1.default, { key: row.id },
                        react_1.default.createElement(StyledTableCell, { component: "th", scope: "row", className: classes.icon },
                            row.elementType === reportElementTypes_1.ReportElementTypes.Folder && (react_1.default.createElement(icons_1.FolderOutlined, null)),
                            row.elementType === reportElementTypes_1.ReportElementTypes.Dashboard && (react_1.default.createElement(icons_1.DashboardOutlined, null)),
                            row.elementType === reportElementTypes_1.ReportElementTypes.Look && (react_1.default.createElement(icons_1.AssessmentOutlined, null))),
                        react_1.default.createElement(StyledTableCell, { scope: "row" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: classes.customNavLink, to: `${row.basePath}` }, row.name)),
                        showDashboardCount && (react_1.default.createElement(StyledTableCell, { align: "right" }, row.elementType === reportElementTypes_1.ReportElementTypes.Folder
                            ? row.dashboards
                            : '--')),
                        showLookCount && (react_1.default.createElement(StyledTableCell, { align: "right" }, row.elementType === reportElementTypes_1.ReportElementTypes.Folder
                            ? row.looks
                            : '--')),
                        showOwner && (react_1.default.createElement(StyledTableCell, null, row.elementType === reportElementTypes_1.ReportElementTypes.Folder
                            ? '--'
                            : row.createdBy)),
                        showFavorite && (react_1.default.createElement(StyledTableCell, null, row.elementType === reportElementTypes_1.ReportElementTypes.Folder ? ('--') : (react_1.default.createElement(FavoriteContentButton_1.default, { elementType: row.elementType, liked: row.contentFavoriteId !== null, contentMetadataId: row.contentMetadataId, contentFavoriteId: row.contentFavoriteId, handleOnDeleteFavorite: (contentFavoriteId) => {
                                if (removeFavoriteFromTable)
                                    setTableRow((0, handleOnDeleteFavorite_1.default)({
                                        content: tableRow ?? [],
                                        contentFavoriteId: contentFavoriteId,
                                    }));
                            } })))),
                        (0, ShowMoveFunction_1.showKebabMenu)({ report: row }) ? (react_1.default.createElement(StyledTableCell, { className: classes.kebabColumn }, canSeeKebabMenu(row) && (react_1.default.createElement(ReportOptionsColumn_1.default, { showEdit: row.can?.editContent || row.can?.update, showDelete: row.can?.editContent || row.can?.destroy, enableDelete: row.elementType === reportElementTypes_1.ReportElementTypes.Folder, showMove: (0, ShowMoveFunction_1.showMoveFunction)({ report: row }), row: row })))) : (react_1.default.createElement(StyledTableCell, null))));
                }))))),
        !hasContent() && (react_1.default.createElement(EmptyFolderState_1.default, { showCreateButton: showCreateButton }))));
};
exports.default = SubFolderTableView;
